// extracted by mini-css-extract-plugin
module.exports = {"checkboxHolder":"_2dra0","semiCheck":"_2-CNJ"};